/* eslint-disable */
/**
 * Əmək Müqaviləsinə Xitam və Son Haqq-hesab Kalkulyatoru (2026)
 * Əsas Spesifikasiya: Revision 24 (Final Approved)
 * 
 * Hüquqi Baza:
 * - AR Əmək Məcəlləsi (ƏM):
 *   - Maddə 68, 69, 70 (a, b, c, ç), 73, 74 (1-ci hissə: a, b, c, ç, d, e)
 *   - Maddə 77 (77.1, 77.3, 77.4, 77.5, 77.7)
 *   - Maddə 114, 115, 116, 117 (117.1, 117.2), 118-1
 *   - Maddə 140 (140.2: 30.4 əmsalı), Maddə 144
 *   - Maddə 157, 177 (177.2: son 2 təqvim ayı)
 * - AR Konstitusiya Məhkəməsinin 18.02.2026-cı il tarixli Qərarı (Əlavə məzuniyyətlərin kompensasiyası)
 * - AR Vergi Məcəlləsi:
 *   - Maddə 101.1-1 (2026 gəlir vergisi pillələri)
 *   - Maddə 102.1.4 (Xitam müavinətlərinin azadolması)
 *   - Maddə 102.1.6 (200 AZN vergi güzəşti, hər iş ili üzrə ayrılıqda)
 * - "Sosial sığorta haqqında" AR Qanunu (Maddə 14, Maddə 15)
 * - "İcbari tibbi sığorta haqqında" AR Qanunu (Maddə 15-10: 2%)
 * - "İşsizlikdən sığorta haqqında" AR Qanunu (Maddə 9: 0.5%)
 * - AR Nazirlər Kabinetinin 09.06.1997-ci il tarixli 58 nömrəli Qərarı (Yanaşma A)
 * - AR Dövlət Vergi Xidmətinin 11.08.2026 və 29.04.2026 rəsmi inzibati izahları (Yanaşma B)
 * - AR ƏƏSMN 2026-cı il İstehsalat Təqvimi (241 iş günü)
 */

export const STATUTORY_CONSTANTS = {
  AVERAGE_MONTH_CALENDAR_DAYS: 30.4, // ƏM 140.2
  ANNUAL_WORK_DAYS_2026: 241, // 2026 İstehsalat Təqvimi
  MONTHLY_WORK_DAYS_AVERAGE_2026: 241 / 12, // 20.0833 (Model A Audit Simulyasiyası)
  TAX_FREE_ALLOWANCE_VM_102_1_6: 200.0, // 200 AZN güzəşt
  CONSTITUTIONAL_COURT_DATE: '2026-02-18', // KM Qərarı qüvvə tarixi
};

/**
 * 1. Staj üzrə qanunla müəyyən edilmiş minimum işdənçıxarma müavinəti əmsalı (ƏM 77.3)
 * Qeyd: Maddə 77.3 "azı" tələb edir (qanuni minimumdur).
 */
export function getStatutorySeveranceMultiplier(seniorityYears) {
  if (seniorityYears < 1) return 1.0;
  if (seniorityYears < 5) return 1.4;
  if (seniorityYears <= 10) return 1.7; // Tam 10 il = 1.7
  return 2.0; // 10 ildən çox = 2.0
}

/**
 * 2. Staj üzrə xəbərdarlıq təqvim günləri və baza kompensasiya əmsalı (ƏM 77.1 və 77.4)
 * YALNIZ ƏM 70 "b" (ixtisar) xitamına şamil olunur.
 */
export function getStatutoryNoticeDays(seniorityYears) {
  if (seniorityYears < 1) return 14; // 2 təqvim həftəsi
  if (seniorityYears < 5) return 28; // 4 təqvim həftəsi
  if (seniorityYears <= 10) return 42; // 6 təqvim həftəsi (tam 10 il daxil)
  return 63; // 9 təqvim həftəsi (10 ildən çox)
}

export function getStatutoryNoticeMultiplier(seniorityYears) {
  if (seniorityYears < 1) return 0.5;
  if (seniorityYears < 5) return 0.9;
  if (seniorityYears <= 10) return 1.4;
  return 2.0;
}

/**
 * 3. ƏM 77.4 üzrə xəbərdarlıq kompensasiyasının hesablanması
 * Şərtlər:
 * - Xitam əsası YALNIZ 70 "b" (ixtisar) olmalıdır.
 * - İşçinin yazılı razılığı olmalıdır.
 * - Ötmüş/keçmiş təqvim günlərinə mütənasib azaldılır (ƏM 77.4 ikinci cümlə).
 */
export function calculateNoticeCompensation({
  terminationGround,
  seniorityYears,
  hasEmployeeConsent,
  elapsedNoticeCalendarDays = 0,
  oma = 0,
}) {
  if (terminationGround !== '70_b') {
    return 0.0;
  }

  if (!hasEmployeeConsent) {
    return 0.0;
  }

  const statutoryDays = getStatutoryNoticeDays(seniorityYears);
  const baseMultiplier = getStatutoryNoticeMultiplier(seniorityYears);

  const elapsed = Math.min(Math.max(0, elapsedNoticeCalendarDays), statutoryDays);
  const remainingDays = statutoryDays - elapsed;
  const proportion = statutoryDays > 0 ? remainingDays / statutoryDays : 0;

  const amount = baseMultiplier * oma * proportion;
  return Number(amount.toFixed(2));
}

/**
 * 4. Xitam əsası üzrə qanuni minimum işdənçıxarma müavinətinin hesablanması (ƏM 77.3, 77.5, 77.7)
 */
export function calculateStatutoryMinimumSeverance({
  terminationGround,
  seniorityYears = 0,
  oma = 0,
}) {
  switch (terminationGround) {
    case '70_a': // Müəssisənin ləğvi
    case '70_b': // İxtisar
      return {
        amount: Number((getStatutorySeveranceMultiplier(seniorityYears) * oma).toFixed(2)),
        multiplier: getStatutorySeveranceMultiplier(seniorityYears),
        isLegalMin: true,
        status: 'DEFINED',
        rule: 'ƏM m.77.3 (Qanuni minimum müavinət)',
      };

    case '74_1_a': // Hərbi xidmətə çağırılma
    case '74_1_c': // 6 aydan çox fasiləsiz əmək qabiliyyətinin itirilməsi
      return {
        amount: Number((2.0 * oma).toFixed(2)),
        multiplier: 2.0,
        isLegalMin: true,
        status: 'DEFINED',
        rule: 'ƏM m.77.7 (Azı 2.0x OMA)',
      };

    case '74_1_e': // İşçinin vəfatı / itkin düşməsi
      return {
        amount: Number((3.0 * oma).toFixed(2)),
        multiplier: 3.0,
        isLegalMin: true,
        status: 'DEFINED',
        rule: 'ƏM m.77.7 (Vərəsələrə azı 3.0x OMA)',
      };

    case '63_2_and_68_2_ch': // Mülkiyyətçi dəyişməsi (rəhbər heyət)
      return {
        amount: Number((3.0 * oma).toFixed(2)),
        multiplier: 3.0,
        isLegalMin: true,
        status: 'DEFINED',
        rule: 'ƏM m.63.2 + 68.2(ç) (Rəhbər heyət üzrə azı 3.0x OMA)',
      };

    case '74_1_b': // Əvvəlki işçinin bərpası
    case '74_1_d': // Fəaliyyət qabiliyyətsizliyi
      return {
        amount: 0.0,
        multiplier: 0.0,
        isLegalMin: false,
        status: 'LEGAL_VERIFICATION_REQUIRED',
        rule: 'ƏM 74 üzrə hüquqi status ayrıca təsdiq tələb edir (avtomatik müavinət hesablanmır)',
      };

    case '70_c': // Attestasiya
    case '70_ch': // Kobud pozuntu
    case '68_2_b': // Müddətli bitmə
    case '69': // Öz xahişi ilə istefa
    case '74_1_ch': // Məhkəmə hökmü ilə məhrumetmə
    default:
      return {
        amount: 0.0,
        multiplier: 0.0,
        isLegalMin: false,
        status: 'NONE',
        rule: 'Qanuni işdənçıxarma müavinəti nəzərdə tutulmur',
      };
  }
}

/**
 * 5. ƏM 115, 116, 117, 118-1 üzrə fərdi əlavə məzuniyyət hüququnun yoxlanması
 */
export function checkAdditionalVacationEligibility({
  seniorityYears = 0,
  hasHazardousConditions = false,
  hazardousDays = 0, // ƏM 115 (NK 66 üzrə ən azı 6 gün)
  gender = 'female',
  isSingleFather = false,
  isAdoptiveParent = false,
  childrenUnder14Count = 0,
  disabledChildUnder18Count = 0,
  isLiberatedTerritorySpecialist = false, // ƏM 118-1
}) {
  const breakdown = {
    conditionDays: 0,
    seniorityDays: 0,
    childrenDays: 0,
    specialNatureDays: 0,
    totalEligibleDaysPerYear: 0,
  };

  // ƏM 115: Əmək şəraitinə görə
  if (hasHazardousConditions) {
    breakdown.conditionDays = Math.max(6, Number(hazardousDays) || 6);
  }

  // ƏM 116: Əmək stajına görə
  if (seniorityYears >= 15) {
    breakdown.seniorityDays = 6;
  } else if (seniorityYears >= 10) {
    breakdown.seniorityDays = 4;
  } else if (seniorityYears >= 5) {
    breakdown.seniorityDays = 2;
  }

  // ƏM 117: Uşaqlı işçilər və tək valideynlər
  const isEligibleForChildrenLeave =
    gender === 'female' || isSingleFather || isAdoptiveParent;

  if (isEligibleForChildrenLeave) {
    if (childrenUnder14Count >= 3 || disabledChildUnder18Count >= 1) {
      breakdown.childrenDays = 5;
    } else if (childrenUnder14Count === 2) {
      breakdown.childrenDays = 2;
    }
  }

  // ƏM 118-1: İşğaldan azad edilmiş ərazilərdə çalışan mütəxəssislər
  if (isLiberatedTerritorySpecialist) {
    breakdown.specialNatureDays = 5;
  }

  breakdown.totalEligibleDaysPerYear =
    breakdown.conditionDays +
    breakdown.seniorityDays +
    breakdown.childrenDays +
    breakdown.specialNatureDays;

  return breakdown;
}

/**
 * 6. 2026-cı il Gəlir Vergisi Hesablanması (VM 101.1-1 və 102.1.6)
 * Qeyri-neft/qaz və qeyri-dövlət sektoru:
 * - 2500 AZN-dək: 3% (200 AZN güzəşt düşüldükdən sonra)
 * - 2500 - 8000 AZN: 75 AZN + (Məbləğ - 2500) × 10%
 * - 8000 AZN-dən çox: 625 AZN + (Məbləğ - 8000) × 14%
 */
export function calculateIncomeTax2026(grossAmount, apply200Allowance = true) {
  const taxable = apply200Allowance
    ? Math.max(0, grossAmount - STATUTORY_CONSTANTS.TAX_FREE_ALLOWANCE_VM_102_1_6)
    : Math.max(0, grossAmount);

  if (taxable <= 0) return 0.0;

  let tax = 0;
  if (taxable <= 2500) {
    tax = taxable * 0.03;
  } else if (taxable <= 8000) {
    tax = 75 + (taxable - 2500) * 0.1;
  } else {
    tax = 625 + (taxable - 8000) * 0.14;
  }

  return Number(tax.toFixed(2));
}

/**
 * 7. 2026-cı il MDSS Hesablanması (Qanun m.14)
 * Muzdlu işçi:
 * - 200 AZN-dək: 3%
 * - 200 AZN-dən çox: 6 AZN + (Məbləğ - 200) × 10%
 */
export function calculateMDSS2026(grossAmount) {
  if (grossAmount <= 0) return 0.0;

  let mdss = 0;
  if (grossAmount <= 200) {
    mdss = grossAmount * 0.03;
  } else {
    mdss = 6 + (grossAmount - 200) * 0.1;
  }

  return Number(mdss.toFixed(2));
}

/**
 * 8. 2026-cı il İTS (İcbari Tibbi Sığorta) Hesablanması
 * Qeyri-neft/qaz sektoru: 2500 AZN-dək 2%, 2500 AZN-dən yuxarı 50 AZN + 0.5%
 */
export function calculateITS2026(grossAmount) {
  if (grossAmount <= 0) return 0.0;

  let its = 0;
  if (grossAmount <= 2500) {
    its = grossAmount * 0.02;
  } else {
    its = 50 + (grossAmount - 2500) * 0.005;
  }

  return Number(its.toFixed(2));
}

/**
 * 9. 2026-cı il İŞS (İşsizlikdən Sığorta) Hesablanması (0.5%)
 */
export function calculateISS2026(grossAmount) {
  if (grossAmount <= 0) return 0.0;
  return Number((grossAmount * 0.005).toFixed(2));
}

/**
 * 10. Əsas Hesablama Mühərriki
 */
export function calculateFinalSettlement2026(input) {
  const {
    monthlySalary = 3400,
    terminationDate = '2026-03-31',
    terminationGround = '70_b',
    seniorityYears = 7,
    actualDaysWorkedInMonth = 10,
    normDaysInMonth = 17,
    hasEmployeeConsent = true,
    elapsedNoticeCalendarDays = 0,
    // Son 2 ayın göstəricisi (ƏM 177.2)
    lastTwoMonthsTotalEarnings = 6800,
    lastTwoMonthsWorkDays = 41,
    // Növbəti ayın iş günləri (Model B üçün)
    nextMonthWorkDays = 22,
    // Məzuniyyət illəri
    vacationYears = [
      { yearLabel: '2024–2025', unusedDays: 8 },
      { yearLabel: '2025–2026', unusedDays: 10 },
    ],
    // Əlavə parametrlər
    actualSeveranceAmount = null, // İstifadəçinin daxil etdiyi faktiki məbləğ
  } = input;

  // A. Cari Ayın Faktiki Əməkhaqqı (Blok 0)
  const dailyRate = normDaysInMonth > 0 ? monthlySalary / normDaysInMonth : 0;
  const currentMonthSalaryGross = Number((dailyRate * actualDaysWorkedInMonth).toFixed(2));

  const currentMonthGV = calculateIncomeTax2026(currentMonthSalaryGross, true);
  const currentMonthMDSS = calculateMDSS2026(currentMonthSalaryGross);
  const currentMonthITS = calculateITS2026(currentMonthSalaryGross);
  const currentMonthISS = calculateISS2026(currentMonthSalaryGross);
  const currentMonthTotalDeductions = Number(
    (currentMonthGV + currentMonthMDSS + currentMonthITS + currentMonthISS).toFixed(2)
  );

  // B. İstifadə Edilməmiş Məzuniyyət Kompensasiyası (ƏM 140 və 144)
  // OGQ_140 = Son 12 ayın qazancı / (12 * 30.4) = monthlySalary / 30.4
  const OGQ_140 = monthlySalary / STATUTORY_CONSTANTS.AVERAGE_MONTH_CALENDAR_DAYS;

  let totalVacationGross = 0;
  let vacationDeductionsApproachA = 0; // NK №58: MDSS = 0
  let vacationDeductionsApproachB = 0; // DVX 11.08.2026: MDSS tətbiq olunur

  const vacationBreakdown = vacationYears.map((item) => {
    const gross = Number((item.unusedDays * OGQ_140).toFixed(2));
    totalVacationGross += gross;

    // Hər iş ili üzrə ayrılıqda 200 AZN güzəştlə gəlir vergisi (VM 102.1.6, DVX 11.08.2026)
    const gv = calculateIncomeTax2026(gross, true);
    const its = calculateITS2026(gross);
    const iss = calculateISS2026(gross);

    // Yanaşma A: NK №58, bənd 1 üzrə MDSS = 0
    const mdssA = 0.0;
    const totalA = Number((gv + mdssA + its + iss).toFixed(2));
    vacationDeductionsApproachA += totalA;

    // Yanaşma B: DVX 11.08.2026 izahı üzrə MDSS hesablanır (ayrılıqda)
    const mdssB = calculateMDSS2026(gross);
    const totalB = Number((gv + mdssB + its + iss).toFixed(2));
    vacationDeductionsApproachB += totalB;

    return {
      yearLabel: item.yearLabel,
      unusedDays: item.unusedDays,
      dailyRate: Number(OGQ_140.toFixed(4)),
      gross,
      gv,
      its,
      iss,
      mdssApproachA: mdssA,
      mdssApproachB: mdssB,
      totalDeductionsApproachA: totalA,
      totalDeductionsApproachB: totalB,
    };
  });

  totalVacationGross = Number(totalVacationGross.toFixed(2));
  vacationDeductionsApproachA = Number(vacationDeductionsApproachA.toFixed(2));
  vacationDeductionsApproachB = Number(vacationDeductionsApproachB.toFixed(2));

  // C. ƏM 177.2 Bir Günlük Orta Əməkhaqqı (OGQ_177)
  const OGQ_177 =
    lastTwoMonthsWorkDays > 0 ? lastTwoMonthsTotalEarnings / lastTwoMonthsWorkDays : 0;

  // D. Simulyasiya Modelləri üzrə OMA Hesablanması
  // Model A: 241/12 = 20.0833 (İnzibati metodika üzrə 4 rəqəmli yuvarlaqlaşdırılmış OGQ ilə)
  const roundedOGQ_177 = Number(OGQ_177.toFixed(4));
  const omaModelA = Number(
    (roundedOGQ_177 * (STATUTORY_CONSTANTS.ANNUAL_WORK_DAYS_2026 / 12)).toFixed(2)
  ); // 165.8537 * (241 / 12) = 3330.90 AZN
  // Model B: Növbəti ayın iş günləri
  const omaModelB = Number((roundedOGQ_177 * nextMonthWorkDays).toFixed(2));
  // Model C: Sabit vəzifə maaşı nəzarəti
  const omaModelC = Number(monthlySalary.toFixed(2));

  // E. Qanuni Minimum Müavinət və Xəbərdarlıq Kompensasiyası Hesabı (Model A üçün)
  const statutoryMinResultModelA = calculateStatutoryMinimumSeverance({
    terminationGround,
    seniorityYears,
    oma: omaModelA,
  });

  const noticeCompModelA = calculateNoticeCompensation({
    terminationGround,
    seniorityYears,
    hasEmployeeConsent,
    elapsedNoticeCalendarDays,
    oma: omaModelA,
  });

  // Model B üçün
  const statutoryMinResultModelB = calculateStatutoryMinimumSeverance({
    terminationGround,
    seniorityYears,
    oma: omaModelB,
  });
  const noticeCompModelB = calculateNoticeCompensation({
    terminationGround,
    seniorityYears,
    hasEmployeeConsent,
    elapsedNoticeCalendarDays,
    oma: omaModelB,
  });

  // Model C üçün
  const statutoryMinResultModelC = calculateStatutoryMinimumSeverance({
    terminationGround,
    seniorityYears,
    oma: omaModelC,
  });
  const noticeCompModelC = calculateNoticeCompensation({
    terminationGround,
    seniorityYears,
    hasEmployeeConsent,
    elapsedNoticeCalendarDays,
    oma: omaModelC,
  });

  // F. Cəmi Brüt və Net Hesablanması
  // Model A üzrə
  const totalGrossModelA = Number(
    (
      currentMonthSalaryGross +
      totalVacationGross +
      statutoryMinResultModelA.amount +
      noticeCompModelA
    ).toFixed(2)
  );

  // Müavinət və xəbərdarlıq tam azaddır (VM 102.1.4, SSQ 15)
  const totalDeductionsApproachA = Number(
    (currentMonthTotalDeductions + vacationDeductionsApproachA).toFixed(2)
  );
  const totalDeductionsApproachB = Number(
    (currentMonthTotalDeductions + vacationDeductionsApproachB).toFixed(2)
  );

  const netPayApproachA_ModelA = Number(
    (totalGrossModelA - totalDeductionsApproachA).toFixed(2)
  );
  const netPayApproachB_ModelA = Number(
    (totalGrossModelA - totalDeductionsApproachB).toFixed(2)
  );

  // Model B üzrə
  const totalGrossModelB = Number(
    (
      currentMonthSalaryGross +
      totalVacationGross +
      statutoryMinResultModelB.amount +
      noticeCompModelB
    ).toFixed(2)
  );
  const netPayApproachA_ModelB = Number(
    (totalGrossModelB - totalDeductionsApproachA).toFixed(2)
  );
  const netPayApproachB_ModelB = Number(
    (totalGrossModelB - totalDeductionsApproachB).toFixed(2)
  );

  // Model C üzrə
  const totalGrossModelC = Number(
    (
      currentMonthSalaryGross +
      totalVacationGross +
      statutoryMinResultModelC.amount +
      noticeCompModelC
    ).toFixed(2)
  );
  const netPayApproachA_ModelC = Number(
    (totalGrossModelC - totalDeductionsApproachA).toFixed(2)
  );
  const netPayApproachB_ModelC = Number(
    (totalGrossModelC - totalDeductionsApproachB).toFixed(2)
  );

  return {
    inputs: input,
    dailyRateOGQ140: Number(OGQ_140.toFixed(4)),
    dailyRateOGQ177: Number(OGQ_177.toFixed(4)),

    // Blok 0: Cari Maaş
    currentMonthSalary: {
      gross: currentMonthSalaryGross,
      gv: currentMonthGV,
      mdss: currentMonthMDSS,
      its: currentMonthITS,
      iss: currentMonthISS,
      totalDeductions: currentMonthTotalDeductions,
    },

    // Blok 1 & 2: Məzuniyyət
    vacation: {
      totalGross: totalVacationGross,
      breakdown: vacationBreakdown,
      totalDeductionsApproachA: vacationDeductionsApproachA,
      totalDeductionsApproachB: vacationDeductionsApproachB,
    },

    // Audit Simulyasiyaları
    simulations: {
      modelA: {
        title: 'Audit Simulyasiyası A (241/12 Metodik Əmsalı)',
        status: 'UNVERIFIED_ADMINISTRATIVE_PRACTICE',
        statusLabel: 'NORMATİV MƏCBURİLİYİ TƏSDİQLƏNMƏYİB — İNZİBATİ METODİKA',
        oma: omaModelA,
        statutoryMinSeverance: statutoryMinResultModelA.amount,
        noticeCompensation: noticeCompModelA,
        totalGross: totalGrossModelA,
        netApproachA: netPayApproachA_ModelA,
        netApproachB: netPayApproachB_ModelA,
      },
      modelB: {
        title: 'Audit Simulyasiyası B (Xitamdan Sonrakı Ayın İş Günləri)',
        status: 'UNVERIFIED_ALTERNATIVE_INTERPRETATION',
        statusLabel: 'NORMATİV MƏCBURİLİYİ TƏSDİQLƏNMƏYİB — ALTERNATİV İNTERPRETASİYA',
        oma: omaModelB,
        statutoryMinSeverance: statutoryMinResultModelB.amount,
        noticeCompensation: noticeCompModelB,
        totalGross: totalGrossModelB,
        netApproachA: netPayApproachA_ModelB,
        netApproachB: netPayApproachB_ModelB,
      },
      modelC: {
        title: 'Nəzarət C (Sabit Vəzifə Maaşı)',
        status: 'VALIDATION_CONTROL_CASE',
        statusLabel: 'NƏZARƏT HESABI (SABİT MAAŞ)',
        oma: omaModelC,
        statutoryMinSeverance: statutoryMinResultModelC.amount,
        noticeCompensation: noticeCompModelC,
        totalGross: totalGrossModelC,
        netApproachA: netPayApproachA_ModelC,
        netApproachB: netPayApproachB_ModelC,
      },
    },

    // Yanaşmalar üzrə cəmi tutulmalar
    deductions: {
      approachA: {
        label: 'Qüvvədə olan normativ hüquqi aktın birbaşa müddəasına əsaslanan hesab (NK №58)',
        mdssOnVacation: 0.0,
        totalDeductions: totalDeductionsApproachA,
      },
      approachB: {
        label: 'Dövlət Vergi Xidmətinin rəsmi inzibati izahında ifadə edilmiş tətbiq mövqeyinə əsaslanan hesab (DVX 11.08.2026)',
        mdssOnVacation: Number((vacationDeductionsApproachB - vacationDeductionsApproachA).toFixed(2)),
        totalDeductions: totalDeductionsApproachB,
      },
    },
  };
}
